export function parseShipmentDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const asp = (params.get('asp') || '').trim();
  const shipmentIdRaw = params.get('shipmentId');
  const shipmentId = shipmentIdRaw ? Number(shipmentIdRaw) : null;

  if (!(Number.isFinite(shipmentId) && shipmentId > 0) && !asp) {
    return null;
  }

  return {
    shipmentId: Number.isFinite(shipmentId) && shipmentId > 0 ? shipmentId : null,
    asp,
  };
}
